var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOraBukurIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 132.551,
    height: 142.077,
    viewBox: "0 0 132.551 142.077",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1474",
    "data-name": "Rectangle 1474",
    width: 132.551,
    height: 142.077,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5157",
    "data-name": "Group 5157",
    transform: "translate(19894 12132)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5156",
    "data-name": "Group 5156",
    transform: "translate(-19894 -12132)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5155",
    "data-name": "Group 5155",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8118",
    "data-name": "Path 8118",
    d: "M115.6,57.8A57.8,57.8,0,1,1,57.8,0a57.8,57.8,0,0,1,57.8,57.8",
    fill: "#1d3943"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8119",
    "data-name": "Path 8119",
    d: "M75.172,94.7c10.43-4.208,19.9-11.207,26.037-20.63,7.132-10.943,9.286-24.215,8.661-37.416A52.74,52.74,0,0,0,20.551,92.643c16.925,8,37.211,9.077,54.621,2.054",
    transform: "translate(-8.361 -8.362)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8120",
    "data-name": "Path 8120",
    d: "M121.637,75c.625,13.2-1.529,26.473-8.661,37.417-6.141,9.423-15.607,16.422-26.037,20.629-17.41,7.024-37.7,5.948-54.622-2.054A52.739,52.739,0,1,0,121.637,75",
    transform: "translate(-20.128 -46.713)",
    fill: "#eef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8121",
    "data-name": "Path 8121",
    d: "M110.746,118.526,85.936,96.409,111.9,117.163Z",
    transform: "translate(-53.523 -60.046)",
    fill: "#1d3943"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8122",
    "data-name": "Path 8122",
    d: "M152.6,151.582l11.45,42.032-13.426-40.781Z",
    transform: "translate(-93.811 -94.41)",
    fill: "#1d3943"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8123",
    "data-name": "Path 8123",
    d: "M150.695,146.788a3.907,3.907,0,1,1-3.907-3.907,3.907,3.907,0,0,1,3.907,3.907",
    transform: "translate(-88.99 -88.99)",
    fill: "#1DA092"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8124",
    "data-name": "Path 8124",
    d: "M152.031,24.158a.732.732,0,0,1-.732-.732V12.216a.732.732,0,1,1,1.464,0v11.21a.732.732,0,0,1-.732.732",
    transform: "translate(-94.233 -7.153)",
    fill: "#1d3943"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8125",
    "data-name": "Path 8125",
    d: "M152.031,274.066a.732.732,0,0,1-.732-.732v-11.21a.732.732,0,1,1,1.464,0v11.21a.732.732,0,0,1-.732.732",
    transform: "translate(-94.233 -162.802)",
    fill: "#1d3943"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8126",
    "data-name": "Path 8126",
    d: "M273.334,152.763h-11.21a.732.732,0,0,1,0-1.465h11.21a.732.732,0,0,1,0,1.465",
    transform: "translate(-162.802 -94.233)",
    fill: "#1d3943"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8127",
    "data-name": "Path 8127",
    d: "M23.426,152.763H12.216a.732.732,0,0,1,0-1.465h11.21a.732.732,0,0,1,0,1.465",
    transform: "translate(-7.153 -94.233)",
    fill: "#1d3943"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8128",
    "data-name": "Path 8128",
    d: "M43.478,83.8a.729.729,0,0,1-.392-.114l-9.462-6.011a.732.732,0,1,1,.785-1.236l9.462,6.011a.732.732,0,0,1-.393,1.351",
    transform: "translate(-20.73 -47.539)",
    fill: "#1d3943"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8129",
    "data-name": "Path 8129",
    d: "M254.419,217.808a.729.729,0,0,1-.392-.114l-9.462-6.011a.732.732,0,0,1,.785-1.236l9.462,6.011a.732.732,0,0,1-.393,1.35",
    transform: "translate(-152.11 -131.001)",
    fill: "#1d3943"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8130",
    "data-name": "Path 8130",
    d: "M211.065,44.211a.733.733,0,0,1-.618-1.125l6.011-9.462a.732.732,0,0,1,1.236.785l-6.011,9.462a.731.731,0,0,1-.619.34",
    transform: "translate(-131.001 -20.73)",
    fill: "#1d3943"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8131",
    "data-name": "Path 8131",
    d: "M77.059,255.153a.732.732,0,0,1-.617-1.125l6.011-9.462a.732.732,0,1,1,1.236.785l-6.011,9.462a.732.732,0,0,1-.619.339",
    transform: "translate(-47.539 -152.111)",
    fill: "#1d3943"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8132",
    "data-name": "Path 8132",
    d: "M244.958,83.8a.732.732,0,0,1-.393-1.351l9.462-6.011a.732.732,0,1,1,.785,1.236l-9.462,6.011a.73.73,0,0,1-.392.114",
    transform: "translate(-152.11 -47.539)",
    fill: "#1d3943"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8133",
    "data-name": "Path 8133",
    d: "M34.017,217.808a.732.732,0,0,1-.393-1.35l9.462-6.011a.732.732,0,1,1,.785,1.236l-9.462,6.011a.729.729,0,0,1-.392.114",
    transform: "translate(-20.73 -131.001)",
    fill: "#1d3943"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8134",
    "data-name": "Path 8134",
    d: "M83.071,44.211a.731.731,0,0,1-.619-.34l-6.011-9.462a.732.732,0,1,1,1.236-.785l6.011,9.462a.733.733,0,0,1-.617,1.125",
    transform: "translate(-47.538 -20.73)",
    fill: "#1d3943"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8135",
    "data-name": "Path 8135",
    d: "M217.077,255.153a.732.732,0,0,1-.619-.339l-6.011-9.462a.732.732,0,1,1,1.236-.785l6.011,9.462a.732.732,0,0,1-.617,1.125",
    transform: "translate(-131.001 -152.111)",
    fill: "#1d3943"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1471",
    "data-name": "Rectangle 1471",
    width: 62.885,
    height: 48.751,
    transform: "translate(69.776 130.669) rotate(-76.719)",
    fill: "#1d3943"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1472",
    "data-name": "Rectangle 1472",
    width: 62.885,
    height: 48.751,
    transform: "translate(70.657 130.877) rotate(-76.719)",
    fill: "#1d3943"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1473",
    "data-name": "Rectangle 1473",
    width: 53.139,
    height: 40.767,
    transform: "translate(75.384 128.226) rotate(-76.718)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8136",
    "data-name": "Path 8136",
    d: "M278.622,181.065l-14.205-3.353a4.244,4.244,0,0,0-5.105,3.155l-.559,2.368,22.466,5.3.559-2.368a4.244,4.244,0,0,0-3.155-5.105",
    transform: "translate(-161.158 -110.613)",
    fill: "#1d3943"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8137",
    "data-name": "Path 8137",
    d: "M244.458,222.1a3.919,3.919,0,1,1-2.914-4.715,3.92,3.92,0,0,1,2.914,4.715",
    transform: "translate(-147.438 -135.33)",
    fill: "#EEEEFE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8138",
    "data-name": "Path 8138",
    d: "M242.908,225.1a.6.6,0,0,1-.514-.286l-1.638-2.65a.6.6,0,0,1,1.026-.634l1.32,2.137,4.2-2.594a.6.6,0,1,1,.634,1.026l-4.711,2.911a.6.6,0,0,1-.316.09",
    transform: "translate(-149.893 -137.632)",
    fill: "#1DA092"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8139",
    "data-name": "Path 8139",
    d: "M287.964,230.485a.606.606,0,0,1-.139-.016l-21.595-5.1a.6.6,0,1,1,.277-1.174l21.595,5.1a.6.6,0,0,1-.138,1.19",
    transform: "translate(-165.526 -139.626)",
    fill: "#1DA092"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8140",
    "data-name": "Path 8140",
    d: "M286.472,236.807a.605.605,0,0,1-.139-.016l-21.6-5.1a.6.6,0,1,1,.277-1.174l21.6,5.1a.6.6,0,0,1-.138,1.19",
    transform: "translate(-164.597 -143.563)",
    fill: "#1DA092"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8141",
    "data-name": "Path 8141",
    d: "M284.979,243.131a.607.607,0,0,1-.139-.016l-21.595-5.1a.6.6,0,1,1,.277-1.174l21.595,5.1a.6.6,0,0,1-.138,1.19",
    transform: "translate(-163.667 -147.502)",
    fill: "#1DA092"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8142",
    "data-name": "Path 8142",
    d: "M236.858,254.3a3.919,3.919,0,1,1-2.914-4.715,3.919,3.919,0,0,1,2.914,4.715",
    transform: "translate(-142.704 -155.384)",
    fill: "#EEEEFE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8143",
    "data-name": "Path 8143",
    d: "M235.307,257.3a.614.614,0,0,1-.138-.016.6.6,0,0,1-.375-.27l-1.638-2.65a.6.6,0,0,1,1.026-.634l1.32,2.137,4.2-2.595a.6.6,0,1,1,.634,1.026l-4.711,2.912a.6.6,0,0,1-.317.09",
    transform: "translate(-145.16 -157.686)",
    fill: "#1DA092"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8144",
    "data-name": "Path 8144",
    d: "M280.363,262.684a.609.609,0,0,1-.139-.016l-21.6-5.1a.6.6,0,1,1,.277-1.174l21.595,5.1a.6.6,0,0,1-.138,1.19",
    transform: "translate(-160.792 -159.68)",
    fill: "#1DA092"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8145",
    "data-name": "Path 8145",
    d: "M278.871,269.007a.607.607,0,0,1-.139-.016l-21.6-5.1a.6.6,0,1,1,.277-1.174l21.6,5.1a.6.6,0,0,1-.138,1.19",
    transform: "translate(-159.862 -163.619)",
    fill: "#1DA092"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8146",
    "data-name": "Path 8146",
    d: "M277.378,275.33a.605.605,0,0,1-.139-.016l-21.595-5.1a.6.6,0,1,1,.277-1.174l21.595,5.1a.6.6,0,0,1-.138,1.19",
    transform: "translate(-158.933 -167.556)",
    fill: "#1DA092"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8147",
    "data-name": "Path 8147",
    d: "M229.257,286.5a3.919,3.919,0,1,1-2.914-4.715,3.92,3.92,0,0,1,2.914,4.715",
    transform: "translate(-137.97 -175.438)",
    fill: "#EEEEFE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8148",
    "data-name": "Path 8148",
    d: "M227.706,289.5a.614.614,0,0,1-.138-.016.6.6,0,0,1-.375-.27l-1.638-2.65a.6.6,0,0,1,1.026-.634l1.32,2.137,4.2-2.595a.6.6,0,1,1,.634,1.026l-4.711,2.912a.6.6,0,0,1-.317.09",
    transform: "translate(-140.426 -177.741)",
    fill: "#1DA092"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8149",
    "data-name": "Path 8149",
    d: "M272.763,294.883a.607.607,0,0,1-.139-.016l-21.6-5.1a.6.6,0,1,1,.277-1.174l21.595,5.1a.6.6,0,0,1-.138,1.19",
    transform: "translate(-156.058 -179.735)",
    fill: "#1DA092"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8150",
    "data-name": "Path 8150",
    d: "M271.27,301.205a.607.607,0,0,1-.139-.016l-21.595-5.1a.6.6,0,1,1,.277-1.174l21.595,5.1a.6.6,0,0,1-.138,1.19",
    transform: "translate(-155.129 -183.672)",
    fill: "#1DA092"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8151",
    "data-name": "Path 8151",
    d: "M269.778,307.528a.605.605,0,0,1-.139-.016l-21.595-5.1a.6.6,0,1,1,.277-1.174l21.595,5.1a.6.6,0,0,1-.138,1.19",
    transform: "translate(-154.2 -187.61)",
    fill: "#1DA092"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8152",
    "data-name": "Path 8152",
    d: "M274.59,200.244l-29.258-6.906a1.716,1.716,0,0,1-1.276-2.065l.448-1.9,32.6,7.7-.448,1.9a1.716,1.716,0,0,1-2.065,1.276",
    transform: "translate(-151.976 -117.948)",
    fill: "#1d3943"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8153",
    "data-name": "Path 8153",
    d: "M221.891,318.755a3.919,3.919,0,1,1-2.914-4.715,3.919,3.919,0,0,1,2.914,4.715",
    transform: "translate(-133.382 -195.527)",
    fill: "#EEEEFE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8154",
    "data-name": "Path 8154",
    d: "M220.341,321.749a.6.6,0,0,1-.514-.286l-1.638-2.65a.6.6,0,0,1,1.026-.634l1.321,2.137,4.2-2.595a.6.6,0,1,1,.634,1.026l-4.711,2.912a.6.6,0,0,1-.316.09",
    transform: "translate(-135.838 -197.829)",
    fill: "#1DA092"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8155",
    "data-name": "Path 8155",
    d: "M265.4,327.136a.606.606,0,0,1-.139-.016l-21.595-5.1a.6.6,0,0,1,.277-1.175l21.595,5.1a.6.6,0,0,1-.138,1.19",
    transform: "translate(-151.471 -199.823)",
    fill: "#1DA092"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8156",
    "data-name": "Path 8156",
    d: "M263.905,333.46a.6.6,0,0,1-.139-.016l-21.595-5.1a.6.6,0,1,1,.277-1.174l21.595,5.1a.6.6,0,0,1-.138,1.19",
    transform: "translate(-150.542 -203.762)",
    fill: "#1DA092"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8157",
    "data-name": "Path 8157",
    d: "M262.412,339.782a.607.607,0,0,1-.139-.016l-21.595-5.1a.6.6,0,1,1,.277-1.174l21.6,5.1a.6.6,0,0,1-.138,1.19",
    transform: "translate(-149.611 -207.699)",
    fill: "#1DA092"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOraBukurIcon);
export default __webpack_public_path__ + "static/media/ora_bukur_icon.b81e9e746884db86aee61014d53842f5.svg";
export { ForwardRef as ReactComponent };